import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../Redux/selector";
import ComponentInvite from "./ComponentInvite";
import Cookies from "universal-cookie";
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function InviteUser() {
  const cookies = new Cookies();
  const selectorAccount = useSelector(curStateAccount);
  const isLogin = cookies.get("isLoggedIn");
  const { openLogin } = useLoginModal();

  const isAuthed = Boolean(selectorAccount?.userInfo) && Boolean(isLogin);

  useEffect(() => {
    if (!selectorAccount?.userInfo && !isLogin) {
      openLogin();
    }
  }, [selectorAccount?.userInfo]);

  if (isAuthed) {
    return <ComponentInvite isShowPopupLogin={false} />;
  }

  return <ComponentInvite isShowPopupLogin={true} />;
}